<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre4">Vorwort</h3>
<p class="calibre1">Diese kleinen Gedichte sind in Hamburg, Kötzschenbroda, auf
Rügen und in Erkner entstanden. In Erkner die meisten. Ob sie nun
dichterischen Wert haben oder nicht, sie sind da, und ich werde sie
nicht ableugnen. Sie gehen von einfachen Empfindungen aus, und
hierin sehe ich noch immer das Wesen der Lyrik. Nach all diesen
immerhin gesuchten Zufälligkeiten betrat ich in »Fasching« und
»Bahnwärter Thiel« eine ruhige, ernste, aussichtsreiche Bahn. Hier
war jeder Schritt ein Schritt und eröffnete weite, gesunde
Gebiete.</p>
<p class="calibre1">Bücherfreunde haben dies bunte Büchelchen neu aufgelegt. Es
enthält noch heute mehr für mich als für jeden anderen Leser. Bei
jedem seiner Gedichte steigen Situationen, Jahreszeiten der Seele,
Schicksale auf. Insofern ist eine ursprünglich überaus schlichte
Äußerung mit der Zeit zum unerschöpflichen Reichtum für mich
geworden. Möge das bunte Buch seinen Freunden die Liebe und
aufgewandte Mühe nicht ganz unbelohnt lassen.</p>
<p class="right">Santa Margherita Ligure,<br class="calibre2"/>
am 19. März 1924.</p>
<p class="right">Gerhart Hauptmann</p>
<p class="note">Der Wiederabdruck in Band 1 der »Ausgabe letzter
Hand«, Berlin, S. Fischer 1942, ist um die beiden Gedichte »Frau
Julie Schubert ins Stammbuch« und »Widmung an Marie Thienemann«
vermehrt. <a class="pcalibre3 calibre5 pcalibre pcalibre1 pcalibre2" id="page14" title="wedi/Konmax"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?916c461a